/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Border_Style_Outline_ShadowInputs */

const en_video_export_border_style_outline_shadow = /** @type {(inputs: Video_Export_Border_Style_Outline_ShadowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outline + Shadow`)
};

const fr_video_export_border_style_outline_shadow = /** @type {(inputs: Video_Export_Border_Style_Outline_ShadowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contour + ombre`)
};

const de_video_export_border_style_outline_shadow = /** @type {(inputs: Video_Export_Border_Style_Outline_ShadowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontur + Schatten`)
};

const it_video_export_border_style_outline_shadow = /** @type {(inputs: Video_Export_Border_Style_Outline_ShadowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contorno + Ombra`)
};

const ru_video_export_border_style_outline_shadow = /** @type {(inputs: Video_Export_Border_Style_Outline_ShadowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контур + Тень`)
};

const es_video_export_border_style_outline_shadow = /** @type {(inputs: Video_Export_Border_Style_Outline_ShadowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contorno + Sombra`)
};

const zh_cn2_video_export_border_style_outline_shadow = /** @type {(inputs: Video_Export_Border_Style_Outline_ShadowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`轮廓 + 阴影`)
};

const ja_video_export_border_style_outline_shadow = /** @type {(inputs: Video_Export_Border_Style_Outline_ShadowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アウトライン + 影`)
};

const hi_video_export_border_style_outline_shadow = /** @type {(inputs: Video_Export_Border_Style_Outline_ShadowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रूपरेखा + छाया`)
};

const pt_pt2_video_export_border_style_outline_shadow = /** @type {(inputs: Video_Export_Border_Style_Outline_ShadowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contorno + Sombra`)
};

/**
* | output |
* | --- |
* | "Outline + Shadow" |
*
* @param {Video_Export_Border_Style_Outline_ShadowInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_border_style_outline_shadow = /** @type {((inputs?: Video_Export_Border_Style_Outline_ShadowInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Border_Style_Outline_ShadowInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_border_style_outline_shadow(inputs)
	if (locale === "de") return de_video_export_border_style_outline_shadow(inputs)
	if (locale === "it") return it_video_export_border_style_outline_shadow(inputs)
	if (locale === "ru") return ru_video_export_border_style_outline_shadow(inputs)
	if (locale === "es") return es_video_export_border_style_outline_shadow(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_border_style_outline_shadow(inputs)
	if (locale === "ja") return ja_video_export_border_style_outline_shadow(inputs)
	if (locale === "hi") return hi_video_export_border_style_outline_shadow(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_border_style_outline_shadow(inputs)
	return en_video_export_border_style_outline_shadow(inputs)
});